module.exports = __webpack_public_path__ + "img/labmem_icon_whatsapp.2ec750a1.png";